export default ({
  namespaced: true,
  state: {
    view: 'reportDialog',
    values: {
      showDialog: false,
      reportDialogLoading: true,
      reportDialog: true,
      reportDialogTasks: [],
      reportDialogEditedItem: {},
      reportDialogDisable: true,
      selectedTask: false,
      disableTasks: false
    }
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/reportDialog.js